import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./layout/Header";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Footer from "./layout/Footer";
import Client from "./pages/Client";
import WhyMsmesStruggleToHireBlueCollar from "./pages/hiring-guide/why-msmes-struggle-to-hire-blue-collar";
import EmployeeRetention from "./pages/hiring-guide/employee-retention";
import { BestWayToHireBlueCollar } from "./pages/hiring-guide/best-way-to-hire-blue-collar";
import HiringGuide from "./pages/hiring-guide/hiringGuide";
import TAC from "./pages/TAC";
import LanguageSelector from "./components/LanguageSelector";
// import Chatbot from "./components/chatbot";
import Widget from "./components/widget";

function App() {
    return (
        <BrowserRouter
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <Header />
            <LanguageSelector />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/client" element={<Client />} />
                <Route path="/PrivacyPolicy" element={<TAC />} />
                <Route
                    path="/why-msmes-struggle-to-hire-blue-collar"
                    element={<WhyMsmesStruggleToHireBlueCollar />}
                />
                <Route path="/employee-retention" element={<EmployeeRetention />} />
                <Route path="/best-way-to-hire-blue-collar" element={<BestWayToHireBlueCollar />} />
                <Route path="/hiring-guide" element={<HiringGuide />} />
            </Routes>
            {/* <Chatbot /> */}
            <Widget />
            <Footer />
        </BrowserRouter>
    );
}

export default App;